"use client";

import * as React from "react";
import { useThemeManager } from "./useThemeManager";
import { getDefaultThemePreset, DEFAULT_THEME_PRESET } from "./themeConfig";
import { tweakcnThemes } from "./themeData";

const THEME_STORAGE_KEY = "vite-ui-theme-preset";

/**
 * Component that initializes the default theme on app load.
 * Applies the default theme if no user preference is saved, or if the saved theme is invalid.
 * This ensures all users see the same default theme on first visit.
 */
export function ThemeInitializer() {
  const { applyTweakcnTheme, isDarkMode } = useThemeManager();

  React.useEffect(() => {
    const savedTheme = localStorage.getItem(THEME_STORAGE_KEY);
    const defaultTheme = getDefaultThemePreset();

    if (!savedTheme) {
      if (defaultTheme) {
        localStorage.setItem(THEME_STORAGE_KEY, DEFAULT_THEME_PRESET);
        applyTweakcnTheme(defaultTheme.preset, isDarkMode);
      }
    } else {
      const savedThemeExists = tweakcnThemes.some((t) => t.value === savedTheme);
      if (!savedThemeExists) {
        if (defaultTheme) {
          localStorage.setItem(THEME_STORAGE_KEY, DEFAULT_THEME_PRESET);
          applyTweakcnTheme(defaultTheme.preset, isDarkMode);
        }
      } else {
        const theme = tweakcnThemes.find((t) => t.value === savedTheme);
        if (theme) {
          applyTweakcnTheme(theme.preset, isDarkMode);
        }
      }
    }
  }, [applyTweakcnTheme, isDarkMode]);

  return null;
}
